import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  argumentAxisGrid: false,
  valueAxisGrid: true,
  argumentAxisMinorGrid: false,
  valueAxisMinorGrid: false,
};

export const gridSlice = createSlice({
  name: "grid",
  initialState,
  reducers: {
    updateArgumentAxisGrid: (state, action) => {
      return {
        ...state,
        argumentAxisGrid: !state.argumentAxisGrid,
      };
    },
    updateValueAxisGrid: (state, action) => {
      return {
        ...state,
        valueAxisGrid: !state.valueAxisGrid,
      };
    },
    updateArgumentAxisMinorGrid: (state, action) => {
      return {
        ...state,
        argumentAxisMinorGrid: !state.argumentAxisMinorGrid,
      };
    },
    updateValueAxisMinorGrid: (state, action) => {
      return {
        ...state,
        valueAxisMinorGrid: !state.valueAxisMinorGrid,
      };
    },
  },
});

export const {
  updateArgumentAxisGrid,
  updateValueAxisGrid,
  updateArgumentAxisMinorGrid,
  updateValueAxisMinorGrid,
} = gridSlice.actions;

export default gridSlice.reducer;
